import _asyncToGenerator from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import _objectSpread from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import help from "../assets/js/help";
import invitationItem from "./invitationItem";
import { mapState } from "vuex";
export default {
  name: "DetailModal",
  components: {
    invitationItem: invitationItem
  },
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {
          addr: ""
        };
      }
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      border: false,
      finished: false,
      refreshing: false,
      loading: true,
      loadDate: false,
      dialogShow: false,
      dialogAddr: false,
      emptyImage: require("@/assets/images/content-null.png"),
      info: {},
      infoError: {},
      list: [],
      list2: [{}],
      page: 1,
      timer: "",
      chargeCoupeList: [{}]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(["uid", "token", "time", "phone", "isTest", "totalIngral", "type", "activeIndex", "isSelected"])), {}, {
    titleInfo: function titleInfo() {
      if (this.title) {
        return this.title;
      } else {
        return "邀请记录";
      }
    }
  }),
  methods: {
    onClickCopy: function onClickCopy(text) {
      help.copyText2(text);

      _Toast("复制成功");
    },
    onClickClose: function onClickClose() {
      console.log(1);
      this.$emit("update:show", false);
    },
    initPage: function initPage() {
      if (!this.loadDate && this.loading) {
        this.getList();
        this.page += 1;
        this.loadDate = true;
      }
    },
    getList: function getList() {
      var _this = this;

      var _uid = this.uid;
      var _id = this.item.applicationId;
      this.axios.get("/api/activity/my-invitation-user-list?uid=".concat(_uid, "&applicationId=").concat(_id)).then(function (res) {
        if (res) {
          help.requestSuccess(res, true).then(function (res) {
            console.log(res);
            res.forEach(function (e) {
              _this.list.push(e);
            });
            _this.loading = false;
            _this.loadDate = false;
            _this.finished = true;

            if (_this.isTimeOuted) {
              _this.setTimeOut(false);
            }
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this.logout, _this.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    onClickList: function onClickList(item) {
      console.log(item);

      var _id = item.id ? item.id : 1;

      if (process.env.NODE_ENV === "production") {
        this.setAppInfo("");
      }

      this.$router.push({
        path: "/detail/" + _id
      });
    },
    onClickRight: function onClickRight() {
      _Toast("按钮");
    },
    onLoad: function onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
        this.page = 1;
      }

      this.initPage();
    },
    onRefresh: function onRefresh() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.refreshing = true;
                _this2.finished = false;
                _this2.loading = true;

                _this2.onLoad();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};